/* HOUSE OF DAIVA — house layer.
   The labelled cursor, headings that rise, the crossing marquee, the manifesto that lights word by word,
   the fabric swatch, the sealed chapter, the tarot spread, flip cards, the worn coverflow, the size lab,
   the FAQ ring and the namaste in ink. Everything is CSS 3D or plain DOM; one loop drives the moving parts
   and goes to sleep whenever nothing on screen needs it. */
(function () {
  'use strict';
  if (window.__dvHouse) return; window.__dvHouse = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var root = document.documentElement;
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function clamp(x, a, b) { return x < a ? a : x > b ? b : x; }

  /* ---------- one loop that sleeps ---------- */
  var subs = [], vel = 0, lastY = window.pageYOffset, lastT = 0, running = false;
  function on(fn) { subs.push(fn); }
  function wake() { if (running) return; running = true; lastT = 0; requestAnimationFrame(loop); }
  function loop(now) {
    var dt = lastT ? Math.min(64, now - lastT) : 16, y = window.pageYOffset;
    vel += ((y - lastY) / dt - vel) * 0.12; lastY = y; lastT = now;
    if (Math.abs(vel) < 0.002) vel = 0;
    var busy = vel !== 0;
    for (var i = 0; i < subs.length; i++) if (subs[i](now, dt)) busy = true;
    if (busy) requestAnimationFrame(loop); else running = false;
  }
  window.addEventListener('scroll', wake, { passive: true });
  function seen(el, cb, opts) {
    if (!('IntersectionObserver' in window)) { cb(true); wake(); return; }
    new IntersectionObserver(function (en) { en.forEach(function (x) { cb(x.isIntersecting, x); if (x.isIntersecting) wake(); }); }, opts || { rootMargin: '80px' }).observe(el);
  }

  /* ---------- headings rise in ---------- */
  function initRise() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var sel = '.pd-h,.pd-legend__t,.page-head h1,.grid-sec__title,.lb__title,.spec__head,.news__head,.coll-hero h1,.about-body h2,.lab__h,.pdp-rev__t,.manifesto__foot p';
    var els = $$(sel).filter(function (el) { return !el.closest('[data-hx]'); });
    if (!els.length) return;
    root.classList.add('hd-js');
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.setAttribute('data-rise', ''); io.observe(el); });
  }

  /* ---------- cursor that says what you can do (desktop) ---------- */
  function initCursor() {
    if (!fine || reduce) return;
    var c = document.createElement('div'); c.className = 'hd-cur'; c.setAttribute('aria-hidden', 'true'); c.innerHTML = '<span></span>';
    document.body.appendChild(c);
    var label = c.firstChild, tx = -100, ty = -100, x = -100, y = -100, state = '';
    var MAP = [
      ['[data-turn-stage]', 'Turn'], ['[data-sw]', 'Turn'], ['[data-loupe]', 'Look'],
      ['.lb__track,.pd-worn__track', 'Drag'],
      ['.fan__card,.card,.lb__img,.hx__card,.plate__img', 'View'],
      ['a,button,summary,label,select,[role="button"]', '']
    ];
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      tx = e.clientX; ty = e.clientY; c.classList.add('is-on'); wake();
      var t = e.target, found = null;
      for (var i = 0; i < MAP.length; i++) { var hit = t.closest && t.closest(MAP[i][0]); if (hit) { found = MAP[i]; break; } }
      var s = found ? (found[1] ? 'L:' + found[1] : 'H') : '';
      if (s !== state) {
        state = s;
        c.classList.toggle('is-label', s.indexOf('L:') === 0);
        c.classList.toggle('is-hover', s === 'H');
        if (s.indexOf('L:') === 0) label.textContent = found[1];
      }
    }, { passive: true });
    document.addEventListener('pointerleave', function () { c.classList.remove('is-on'); });
    window.addEventListener('blur', function () { c.classList.remove('is-on'); });
    on(function () {
      var dx = tx - x, dy = ty - y;
      if (Math.abs(dx) < 0.1 && Math.abs(dy) < 0.1) return false;
      x += dx * 0.26; y += dy * 0.26;
      c.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
      return true;
    });
  }

  /* ---------- crossing marquee ---------- */
  function initMarquee() {
    $$('[data-mq]').forEach(function (sec) {
      var bands = $$('.mq__band', sec).map(function (band, bi) {
        var track = band.querySelector('.mq__track'), set = track.querySelector('.mq__set');
        var b = { band: band, track: track, set: set, w: 0, x: 0, dir: bi % 2 ? 1 : -1 };
        b.fill = function () {
          b.w = set.offsetWidth || 1;
          while (track.children.length < 12 && track.offsetWidth < band.offsetWidth + b.w * 2) { var cl = set.cloneNode(true); cl.setAttribute('aria-hidden', 'true'); track.appendChild(cl); }
        };
        b.fill();
        return b;
      });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { bands.forEach(function (b) { b.fill(); }); });
      window.addEventListener('resize', function () { bands.forEach(function (b) { b.fill(); }); });
      if (reduce) return;
      var vis = false, sdir = 1; seen(sec, function (v) { vis = v; });
      on(function (now, dt) {
        if (!vis) return false;
        if (vel > 0.02) sdir = 1; else if (vel < -0.02) sdir = -1;
        var boost = 1 + Math.min(5, Math.abs(vel) * 2.2);
        bands.forEach(function (b) {
          b.x += b.dir * sdir * 0.04 * boost * dt;
          if (b.x <= -b.w) b.x += b.w; else if (b.x > 0) b.x -= b.w;
          b.track.style.transform = 'translate3d(' + b.x.toFixed(2) + 'px,0,0)';
        });
        return true;
      });
    });
  }

  /* ---------- manifesto lights up word by word ---------- */
  function initManifesto() {
    $$('.manifesto').forEach(function (sec) {
      var words = [];
      $$('.manifesto__line', sec).forEach(function (line) {
        var parts = line.textContent.split(/(\s+)/); line.textContent = '';
        parts.forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { line.appendChild(document.createTextNode(p)); return; }
          var s = document.createElement('span'); s.className = 'mw'; s.textContent = p; line.appendChild(s); words.push(s);
        });
      });
      if (reduce || !words.length) { words.forEach(function (w) { w.style.opacity = 1; }); return; }
      var vis = false, last = -1; seen(sec, function (v) { vis = v; });
      on(function () {
        if (!vis) return false;
        var r = sec.getBoundingClientRect(), vh = window.innerHeight;
        var p = clamp((vh * 0.82 - r.top) / (r.height * 0.75), 0, 1);
        if (Math.abs(p - last) < 0.001) return false; last = p;
        var lit = p * words.length * 1.12;
        for (var i = 0; i < words.length; i++) words[i].style.opacity = clamp(lit - i, 0.14, 1).toFixed(3);
        sec.style.setProperty('--mp', ((0.5 - p) * 90).toFixed(1) + 'px');
        return false;
      });
    });
  }

  /* ---------- the fabric swatch: a thick slab of the real print ---------- */
  function initSwatch(el) {
    var box = el.querySelector('[data-sw-box]'); if (!box) return;
    var data = []; try { data = JSON.parse(el.querySelector('[data-sw-data]').textContent); } catch (e) {}
    var imgs = [el.querySelector('.sw__face--f img'), el.querySelector('.sw__face--k img')];
    var picks = $$('[data-sw-pick]', el.parentElement);
    var rx = 10, ry = -26, base = 0, baseT = 0, restX = 10, restY = -26, tilt = 0, drag = null, side = 0, cur = 0, vis = false, touched = false;
    function paint() {
      box.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + (ry + base).toFixed(2) + 'deg)';
      box.style.setProperty('--sh', (50 + (ry + base % 360) * 0.9).toFixed(1) + '%');
    }
    el.addEventListener('pointerdown', function (e) {
      drag = { x: e.clientX, y: e.clientY, rx: rx, ry: ry, id: e.pointerId, moved: false };
      if (!touched) { touched = true; el.classList.add('is-touched'); }
    });
    el.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (!drag.moved && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) { drag.moved = true; try { el.setPointerCapture(e.pointerId); } catch (_) {} }
      if (!drag.moved) return;
      ry = drag.ry + dx * 0.45; rx = clamp(drag.rx - dy * 0.25, -22, 34); paint(); wake();
    });
    function release() { drag = null; wake(); }
    el.addEventListener('pointerup', release); el.addEventListener('pointercancel', release); el.addEventListener('lostpointercapture', release);
    function pick(n) {
      if (n === cur || !data[n]) return;
      picks.forEach(function (b, i) { b.setAttribute('aria-pressed', String(i === n)); });
      var hidden = imgs[side ? 0 : 1], im = new Image();
      im.onload = function () {
        hidden.removeAttribute('srcset'); hidden.removeAttribute('sizes'); hidden.src = data[n].src.indexOf('//') === 0 ? location.protocol + data[n].src : data[n].src;
        side = side ? 0 : 1; cur = n; baseT += 180; wake();
      };
      im.src = data[n].src.indexOf('//') === 0 ? location.protocol + data[n].src : data[n].src;
    }
    picks.forEach(function (b, i) { b.addEventListener('click', function () { pick(i); }); });
    seen(el, function (v) { vis = v; });
    paint();
    if (reduce) { on(function () { if (base !== baseT) { base = baseT; paint(); } return false; }); return; }
    on(function () {
      if (!vis) return false;
      var r = el.getBoundingClientRect(), p = clamp((window.innerHeight - r.top) / (window.innerHeight + r.height), 0, 1);
      tilt = (p - 0.5) * 36;
      var moving = false;
      if (!drag) {
        var tx = restX + (0.5 - p) * 10, ty = restY + tilt;
        if (Math.abs(tx - rx) > 0.05 || Math.abs(ty - ry) > 0.05) { rx += (tx - rx) * 0.08; ry += (ty - ry) * 0.08; moving = true; }
      }
      if (Math.abs(baseT - base) > 0.1) { base += (baseT - base) * 0.09; moving = true; } else base = baseT;
      paint();
      return moving || !!drag;
    });
  }

  /* ---------- sealed chapter ---------- */
  function initSeal(el) {
    var card = el.querySelector('.seal__card'); if (!card) return;
    var vis = false; seen(el, function (v) { vis = v; });
    var px = 0, py = 0;
    if (fine) {
      el.addEventListener('pointermove', function (e) { var r = card.getBoundingClientRect(); px = (e.clientX - r.left) / r.width - 0.5; py = (e.clientY - r.top) / r.height - 0.5; card.style.setProperty('--lx', ((px + 0.5) * 100).toFixed(1) + '%'); wake(); });
      el.addEventListener('pointerleave', function () { px = py = 0; wake(); });
    }
    if (reduce) return;
    on(function () {
      if (!vis) return false;
      var r = el.getBoundingClientRect(), p = clamp((window.innerHeight - r.top) / (window.innerHeight + r.height), 0, 1);
      card.style.setProperty('--sy', ((0.5 - p) * 34 + px * 16).toFixed(2) + 'deg');
      card.style.setProperty('--sx', (-py * 12).toFixed(2) + 'deg');
      return false;
    });
  }

  /* ---------- tarot spread ---------- */
  function initFan(el) {
    var cards = $$('.fan__card', el), n = cards.length;
    cards.forEach(function (c, i) { var o = i - (n - 1) / 2; c.style.setProperty('--o', o); c.style.setProperty('--o2', o * o); });
    function deal() { el.classList.add('is-dealt'); setTimeout(function () { el.classList.add('is-settled'); }, 1700); }
    if (reduce) { el.classList.add('is-dealt', 'is-settled'); return; }
    var done = false; seen(el, function (v) { if (v && !done) { done = true; setTimeout(deal, 120); } }, { threshold: 0.2 });
  }

  /* ---------- 3D flip cards ---------- */
  function initFlips() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-card-turn]'); if (!b) return;
      e.preventDefault();
      var wrap = b.closest('.card-wrap'); var on2 = !wrap.classList.contains('is-turned');
      wrap.classList.toggle('is-turned', on2); b.setAttribute('aria-pressed', String(on2));
    });
    if (fine || reduce) return;
    var first = document.querySelector('.card-wrap [data-card-turn]'); if (!first) return;
    try { if (sessionStorage.getItem('dvFlipDemo')) return; } catch (e) {}
    var wrap = first.closest('.card-wrap'), shown = false;
    seen(wrap, function (v) {
      if (!v || shown) return; shown = true;
      try { sessionStorage.setItem('dvFlipDemo', '1'); } catch (e) {}
      setTimeout(function () { wrap.classList.add('is-turned'); first.setAttribute('aria-pressed', 'true'); }, 700);
      setTimeout(function () { wrap.classList.remove('is-turned'); first.setAttribute('aria-pressed', 'false'); }, 2300);
    }, { threshold: 0.6 });
  }

  /* ---------- worn gallery as a coverflow ---------- */
  function initWorn() {
    if (reduce) return;
    $$('[data-worn]').forEach(function (tr) {
      var items = [].slice.call(tr.children), raf = 0;
      function paint() {
        raf = 0;
        var r = tr.getBoundingClientRect(), pad = parseFloat(getComputedStyle(tr).paddingLeft) || 0;
        items.forEach(function (it) {
          var b = it.getBoundingClientRect(), focus = r.left + pad + b.width / 2;
          var a = clamp(((b.left + b.width / 2) - focus) / b.width, -1.5, 1.5);
          it.style.transform = 'rotateY(' + (a * -16).toFixed(2) + 'deg) translateZ(' + (-Math.abs(a) * 70).toFixed(0) + 'px)';
          it.style.filter = 'brightness(' + (1 - Math.min(Math.abs(a), 1) * 0.42).toFixed(3) + ')';
        });
      }
      function req() { if (!raf) raf = requestAnimationFrame(paint); }
      tr.addEventListener('scroll', req, { passive: true }); window.addEventListener('resize', req); paint();
    });
  }

  /* ---------- size lab ---------- */
  function initLab(el) {
    var tbl = document.querySelector('.page-body table'); if (!tbl) { el.hidden = true; return; }
    var rows = $$('tbody tr', tbl).map(function (tr) { var c = tr.children; return { s: (c[0] && c[0].textContent || '').trim(), chest: parseFloat(c[1] && c[1].textContent), len: parseFloat(c[2] && c[2].textContent) }; }).filter(function (r) { return r.s && !isNaN(r.chest) && !isNaN(r.len); });
    if (!rows.length) { el.hidden = true; return; }
    var box = el.querySelector('[data-lab-sizes]'), outC = el.querySelector('[data-lab-chest]'), outL = el.querySelector('[data-lab-len]');
    var cmC = el.querySelector('[data-lab-chest-cm]'), cmL = el.querySelector('[data-lab-len-cm]'), tagC = el.querySelector('[data-lab-tag-c]'), tagL = el.querySelector('[data-lab-tag-l]');
    var btns = rows.map(function (r, i) { var b = document.createElement('button'); b.type = 'button'; b.textContent = r.s; b.setAttribute('aria-pressed', 'false'); b.addEventListener('click', function () { pick(i); }); box.appendChild(b); return b; });
    var cur = -1, shownC = rows[0].chest, shownL = rows[0].len, anim = null;
    function render(c, l) {
      outC.textContent = c.toFixed(0); outL.textContent = l.toFixed(0);
      if (cmC) cmC.textContent = Math.round(c * 2.54) + ' cm'; if (cmL) cmL.textContent = Math.round(l * 2.54) + ' cm';
      if (tagC) tagC.textContent = c.toFixed(0) + ' in'; if (tagL) tagL.textContent = l.toFixed(0) + ' in';
    }
    function pick(i) {
      if (i === cur) return;
      var prev = cur; cur = i;
      btns.forEach(function (b, k) { b.setAttribute('aria-pressed', String(k === i)); });
      var n = rows.length, s = 0.84 + (n > 1 ? i / (n - 1) : 0.5) * 0.2;
      el.style.setProperty('--s', s.toFixed(3));
      if (!reduce && prev >= 0) { el.style.setProperty('--ry', (i > prev ? -9 : 9) + 'deg'); setTimeout(function () { el.style.setProperty('--ry', '0deg'); }, 420); }
      el.classList.remove('is-on'); void el.offsetWidth; el.classList.add('is-on');
      var c0 = shownC, l0 = shownL, c1 = rows[i].chest, l1 = rows[i].len, t0 = performance.now();
      if (anim) cancelAnimationFrame(anim);
      (function tw(now) { var t = reduce ? 1 : clamp((now - t0) / 650, 0, 1), e = 1 - Math.pow(1 - t, 3); shownC = c0 + (c1 - c0) * e; shownL = l0 + (l1 - l0) * e; render(shownC, shownL); if (t < 1) anim = requestAnimationFrame(tw); })(t0);
    }
    var mid = rows.findIndex ? rows.findIndex(function (r) { return r.s === 'M'; }) : -1;
    pick(mid >= 0 ? mid : Math.floor(rows.length / 2));
    el.classList.remove('is-on');
    seen(el, function (v) { if (v) el.classList.add('is-on'); }, { threshold: 0.3 });
  }

  /* ---------- FAQ ring ---------- */
  function initRing(el) {
    var spin = el.querySelector('.ring__spin'); if (!spin) return;
    var items = [].slice.call(spin.children), n = items.length, R = 0, ang = 0, vis = false;
    function size() { var mw = 0; items.forEach(function (it) { mw = Math.max(mw, it.offsetWidth); }); R = Math.max(el.clientWidth * 0.42, mw * n / (2 * Math.PI) * 1.12); items.forEach(function (it, i) { it.style.transform = 'translate(-50%,-50%) rotateY(' + (i * 360 / n) + 'deg) translateZ(' + R + 'px)'; }); }
    function paint() {
      spin.style.transform = 'translateZ(' + (-R) + 'px) rotateX(-3deg) rotateY(' + (-ang).toFixed(2) + 'deg)';
      items.forEach(function (it, i) { var rel = (i * 360 / n - ang) * Math.PI / 180, f = Math.max(0, Math.cos(rel)); it.style.opacity = (0.1 + 0.9 * Math.pow(f, 1.6)).toFixed(3); });
    }
    size(); paint(); window.addEventListener('resize', function () { size(); paint(); });
    if (reduce) return;
    seen(el, function (v) { vis = v; });
    on(function (now, dt) { if (!vis) return false; ang = (ang + dt * 0.0075 + vel * 1.6) % 360; paint(); return true; });
  }

  /* ---------- namaste in ink ---------- */
  function initInk(el) {
    function go() { seen(el, function (v) { if (v) el.classList.add('is-drawn'); }, { threshold: 0.3 }); }
    if (reduce) { el.classList.add('is-drawn'); return; }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(go); else go();
  }

  function boot() {
    initRise(); initCursor(); initMarquee(); initManifesto();
    $$('[data-sw]').forEach(initSwatch);
    $$('[data-seal]').forEach(initSeal);
    $$('[data-fan]').forEach(initFan);
    initFlips(); initWorn();
    $$('[data-lab]').forEach(initLab);
    $$('[data-ring]').forEach(initRing);
    $$('[data-ink]').forEach(initInk);
    wake();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
